var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarRatingFilled = function SvgStarRatingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_638_58469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3.60396L24.6322 13.5389C24.9202 14.2314 25.5714 14.7045 26.319 14.7645L37.0446 15.6243L28.8728 22.6243C28.3032 23.1122 28.0545 23.8778 28.2285 24.6073L30.7251 35.0737L21.5425 29.465C20.9025 29.074 20.0975 29.074 19.4575 29.465L10.2749 35.0737L12.7715 24.6073C12.9455 23.8778 12.6968 23.1122 12.1272 22.6243L3.95538 15.6243L14.681 14.7645C15.4286 14.7045 16.0798 14.2314 16.3678 13.5389L20.5 3.60396Z",
    stroke: "#C4C3C3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_638_58469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5767 3.21993C19.9183 2.39864 21.0817 2.39864 21.4233 3.21993L25.5555 13.1549C25.6995 13.5011 26.0251 13.7377 26.3989 13.7677L37.1245 14.6275C38.0112 14.6986 38.3707 15.8051 37.6952 16.3838L29.5234 23.3838C29.2386 23.6277 29.1142 24.0105 29.2012 24.3753L31.6978 34.8417C31.9042 35.7069 30.963 36.3907 30.2039 35.9271L21.0213 30.3184C20.7012 30.1229 20.2988 30.1229 19.9787 30.3184L10.7961 35.9271C10.037 36.3907 9.09577 35.7069 9.30215 34.8417L11.7988 24.3753C11.8858 24.0105 11.7614 23.6277 11.4766 23.3838L3.30483 16.3838C2.62929 15.8051 2.98882 14.6986 3.87547 14.6275L14.6011 13.7677C14.9749 13.7377 15.3005 13.5011 15.4445 13.1549L19.5767 3.21993Z",
    fill: "#FDB022"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_638_58469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_638_58469"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
export default SvgStarRatingFilled;